module.exports = __webpack_public_path__ + "img/icon_keyboard.c551ea3b.svg";